import { render, staticRenderFns } from "./home-manage.vue?vue&type=template&id=1b913ac0&scoped=true&"
import script from "./home-manage.vue?vue&type=script&lang=js&"
export * from "./home-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b913ac0",
  null
  
)

export default component.exports